exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".in[data-v-93d36296] {\n  display: block;\n}\n.out[data-v-93d36296] {\n  display: none;\n}\n.close[data-v-93d36296] {\n  margin-top: -8px;\n  opacity: 0.9;\n}\n.btn-happy[data-v-93d36296] {\n  padding: 10px 30px;\n}\n.btn-other[data-v-93d36296] {\n  background-color: #259dab;\n  color: #ffffff;\n}", ""]);

// exports
